import Resolution from "../../Resolution/Resolution";
import Zoom from "../../Zoom/Zoom";
import Browser from "../../Browser/Browser";
import Os from "../../Os/Os";

function TopColumns() {
    return (
        <div className="top-columns">
            <div className="top-columns__wrapper">
                <div className="column"><Os/></div>
                <div className="column"><Browser/></div>
                <div className="column"><Resolution/></div>
            </div>
        </div>
    );
}

export default TopColumns;